import {defineRecipe} from '@chakra-ui/react3'

const ageRangeRecipe = defineRecipe({
    base: {},
    variants: {
        variant: {
            'configurator-quickview': {
                color: 'text.brand-default',
                textStyle: 'body.small'
            }
        }
    }
})

export default ageRangeRecipe
